import { useCallback, useEffect, useRef, useState } from "react";
import { useWebSocketContext } from "../contexts/WebSocketProvider";

export default function useFetchAllStations({ groupId = "1" } = {}) {
    const STATIONS_CACHE_KEY = `stations_cache_${groupId}`;

    const [stations, setStations] = useState(() => {
        const cached = localStorage.getItem(STATIONS_CACHE_KEY);
        return cached ? JSON.parse(cached) : [];
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const { send, isConnected, registerHandler } = useWebSocketContext();
    const mountedRef = useRef(true);

    const sortStations = useCallback((stations) => {
        return [...stations].sort((a, b) => parseInt(a.stationId, 10) - parseInt(b.stationId, 10));
    }, []);

     groupId = localStorage.getItem("group_id");


    const persistStations = useCallback((data) => {
        const sorted = sortStations(data);
        setStations(sorted);
        localStorage.setItem(STATIONS_CACHE_KEY, JSON.stringify(sorted));
    }, [sortStations]);

    const fetchAllStations = useCallback(async () => {
        if (!mountedRef.current) return;

        if (!isConnected) {
            setError("WebSocket not connected");
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            const response = await send('cms_get_all_charging_station_details', { 
                group_id: groupId.toString(),
                days: "100"
            });

            if (!response || response.type !== 'cms_get_all_charging_station_details_response') {
                throw new Error('Invalid response from server');
            }

            if (!Array.isArray(response.data)) {
                throw new Error('Server did not return a valid stations list');
            }

            // console.log(response)
            console.log("📥 RESPONSE FROM SEND:", response);

            persistStations(response.data);
        } catch (err) {
            console.error("[WS] Error fetching stations:", err);
            if (mountedRef.current) setError(err.message);
        } finally {
            if (mountedRef.current) setIsLoading(false);
        }
    }, [send, isConnected, groupId, persistStations]);

    // Live updates
    useEffect(() => {
        const unregister = registerHandler('stations_update', (msg) => {
            if (Array.isArray(msg.data) && mountedRef.current) {
                persistStations(msg.data);
            }
        });
        return () => unregister();
    }, [registerHandler, persistStations]);

    useEffect(() => {
        mountedRef.current = true;
        fetchAllStations();

        return () => { mountedRef.current = false; };
    }, [fetchAllStations]);

    return {
        stations,
        isLoading,
        error,
        isConnected,
        refetch: fetchAllStations
    };
}
